

// convert office name to office ID for use generating url to SIMS in tooltip
const getOfficeId = (officeName) => {
    const office = officeToId.data.filter((office) => office.office_nm === officeName)
    if(office.length > 0){
      return office[0].office_id
    }
    return "";
};

// relates a key to a function defined above
export const urlFunctions = {
    "getOfficeId": getOfficeId
};

const officeToId = {
    "data" : [
      {
        "office_id": "1026",
        "office_nm": "Baton Rouge, LA (GW)"
      },
      {
        "office_id": "394",
        "office_nm": "Baton Rouge, LA (QW)"
      },
      {
        "office_id": "301",
        "office_nm": "Fayetteville, AR"
      },
      {
        "office_id": "1057",
        "office_nm": "Fayetteville, AR (GW)"
      },
      {
        "office_id": "328",
        "office_nm": "HIF"
      },
      {
        "office_id": "1058",
        "office_nm": "Jackson, MS (GW)"
      },
      {
        "office_id": "938",
        "office_nm": "Knoxville, TN"
      },
      {
        "office_id": "1059",
        "office_nm": "Knoxville, TN (GW)"
      },
      {
        "office_id": "302",
        "office_nm": "Little Rock, AR"
      },
      {
        "office_id": "1060",
        "office_nm": "Little Rock, AR (GW)"
      },
      {
        "office_id": "1069",
        "office_nm": "Louisiana Watershed Initiative "
      },
      {
        "office_id": "939",
        "office_nm": "Memphis, TN"
      },
      {
        "office_id": "1061",
        "office_nm": "Memphis, TN (GW)"
      },
      {
        "office_id": "901",
        "office_nm": "Montgomery, AL"
      },
      {
        "office_id": "1062",
        "office_nm": "Montgomery, AL (GW)"
      },
      {
        "office_id": "1063",
        "office_nm": "Nashville, TN (GW)"
      },
      {
        "office_id": "362",
        "office_nm": "Ruston, LA"
      },
      {
        "office_id": "1027",
        "office_nm": "Ruston, LA (GW)"
      },
      {
        "office_id": "902",
        "office_nm": "Tuscaloosa, AL"
      },
      {
        "office_id": "1065",
        "office_nm": "Tuscaloosa, AL (GW)"
      },
      {
        "office_id": "940",
        "office_nm": "Nashville, TN"
      },
      {
        "office_id": "1067",
        "office_nm": "CFWSC Studies"
      },
      {
        "office_id": "906",
        "office_nm": "Ft. Lauderdale Office"
      },
      {
        "office_id": "951",
        "office_nm": "Ft. Myers Office"
      },
      {
        "office_id": "904",
        "office_nm": "Orlando Office"
      },
      {
        "office_id": "378",
        "office_nm": "Puerto Rico"
      },
      {
        "office_id": "905",
        "office_nm": "Tallahassee Office"
      },
      {
        "office_id": "907",
        "office_nm": "Tampa Office"
      },
      {
        "office_id": "926",
        "office_nm": "Asheville Field Office"
      },
      {
        "office_id": "909",
        "office_nm": "Atlanta Field Office"
      },
      {
        "office_id": "925",
        "office_nm": "Charlotte Field Office"
      },
      {
        "office_id": "932",
        "office_nm": "Charleston Field Office"
      },
      {
        "office_id": "930",
        "office_nm": "Columbia Field Office"
      },
      {
        "office_id": "947",
        "office_nm": "Investigations Sites"
      },
      {
        "office_id": "924",
        "office_nm": "Raleigh Field Office"
      },
      {
        "office_id": "910",
        "office_nm": "Savannah Field Office"
      },
      {
        "office_id": "911",
        "office_nm": "Tifton Field Office"
      },
      {
        "office_id": "920",
        "office_nm": "BALTIMORE"
      },
      {
        "office_id": "921",
        "office_nm": "DOVER"
      },
      {
        "office_id": "922",
        "office_nm": "FROSTBURG"
      },
      {
        "office_id": "913",
        "office_nm": "CT Networks"
      },
      {
        "office_id": "917",
        "office_nm": "CT Projects"
      },
      {
        "office_id": "915",
        "office_nm": "MA/RI Networks"
      },
      {
        "office_id": "948",
        "office_nm": "MA/RI Projects"
      },
      {
        "office_id": "914",
        "office_nm": "ME Networks"
      },
      {
        "office_id": "1044",
        "office_nm": "ME Projects"
      },
      {
        "office_id": "916",
        "office_nm": "NH/VT Networks"
      },
      {
        "office_id": "1045",
        "office_nm": "NH/VT Projects"
      },
      {
        "office_id": "329",
        "office_nm": "Billings Field Office"
      },
      {
        "office_id": "657",
        "office_nm": "Casper Field Office"
      },
      {
        "office_id": "656",
        "office_nm": "Cheyenne Water Science Center"
      },
      {
        "office_id": "1053",
        "office_nm": "Idaho Falls Field Office for WY-MT"
      },
      {
        "office_id": "331",
        "office_nm": "Helena Field Office"
      },
      {
        "office_id": "332",
        "office_nm": "International Section"
      },
      {
        "office_id": "1054",
        "office_nm": "Montana DNRC"
      },
      {
        "office_id": "377",
        "office_nm": "Montana GW Monitoring"
      },
      {
        "office_id": "658",
        "office_nm": "Riverton Field Office"
      },
      {
        "office_id": "1016",
        "office_nm": "Wyoming GW Monitoring"
      },
      {
        "office_id": "941",
        "office_nm": "Charleston, WV Field Office"
      },
      {
        "office_id": "1007",
        "office_nm": "Leetown, WV Field Office"
      },
      {
        "office_id": "936",
        "office_nm": "Marion, VA Field Office"
      },
      {
        "office_id": "935",
        "office_nm": "Richmond, VA Field Office"
      },
      {
        "office_id": "937",
        "office_nm": "VA Department of Environmental Quality"
      },
      {
        "office_id": "665",
        "office_nm": "Alaska Water Science Center"
      },
      {
        "office_id": "666",
        "office_nm": "Anchorage Field Office"
      },
      {
        "office_id": "667",
        "office_nm": "Fairbanks Field Office"
      },
      {
        "office_id": "668",
        "office_nm": "Juneau Field Office"
      },
      {
        "office_id": "675",
        "office_nm": "Arizona Studies Section"
      },
      {
        "office_id": "601",
        "office_nm": "Flagstaff Field Office"
      },
      {
        "office_id": "603",
        "office_nm": "Tucson Field Office"
      },
      {
        "office_id": "602",
        "office_nm": "Tempe Field Office"
      },
      {
        "office_id": "604",
        "office_nm": "Yuma Field Office"
      },
      {
        "office_id": "1049",
        "office_nm": "Aquatic Ecology Group"
      },
      {
        "office_id": "681",
        "office_nm": "Biogeochemistry and Contaminants"
      },
      {
        "office_id": "1050",
        "office_nm": "California Oil and Gas"
      },
      {
        "office_id": "680",
        "office_nm": "DESN - Geochemistry"
      },
      {
        "office_id": "1043",
        "office_nm": "GAMA"
      },
      {
        "office_id": "610",
        "office_nm": "HMP/Cooperator/Non-USGS"
      },
      {
        "office_id": "617",
        "office_nm": "NoCal - Sac/San Joaquin NAWQA"
      },
      {
        "office_id": "614",
        "office_nm": "Redding - Field Office"
      },
      {
        "office_id": "613",
        "office_nm": "Poway - Field Office &amp; Furnished"
      },
      {
        "office_id": "1030",
        "office_nm": "Redding - Furnished"
      },
      {
        "office_id": "1001",
        "office_nm": "Redlands - AVEK"
      },
      {
        "office_id": "616",
        "office_nm": "Redlands - Field Office &amp; Furnished"
      },
      {
        "office_id": "1002",
        "office_nm": "Redlands - MOJAVE"
      },
      {
        "office_id": "606",
        "office_nm": "Sacramento - Field Office"
      },
      {
        "office_id": "1029",
        "office_nm": "Sacramento - Furnished"
      },
      {
        "office_id": "1006",
        "office_nm": "Sacramento - Projects Office"
      },
      {
        "office_id": "607",
        "office_nm": "San Diego - Projects Office"
      },
      {
        "office_id": "612",
        "office_nm": "Santa Cruz - Field Office"
      },
      {
        "office_id": "1023",
        "office_nm": "Santa Cruz - Furnished"
      },
      {
        "office_id": "1012",
        "office_nm": "Santa Maria - Discrete GW &amp; QW"
      },
      {
        "office_id": "608",
        "office_nm": "Santa Maria - Field Office"
      },
      {
        "office_id": "1014",
        "office_nm": "Santa Maria - Furnished"
      },
      {
        "office_id": "679",
        "office_nm": "SFBD - Hydrodynamics"
      },
      {
        "office_id": "615",
        "office_nm": "SFBD - Sediment Transport"
      },
      {
        "office_id": "611",
        "office_nm": "Truckee - Field Office"
      },
      {
        "office_id": "1017",
        "office_nm": "Truckee - Furnished"
      },
      {
        "office_id": "609",
        "office_nm": "Ukiah - Field Office &amp; Furnished"
      },
      {
        "office_id": "307",
        "office_nm": "Lakewood Field Office"
      },
      {
        "office_id": "310",
        "office_nm": "Cooperator/Non-USGS Sites"
      },
      {
        "office_id": "1031",
        "office_nm": "Projects Pueblo Office"
      },
      {
        "office_id": "309",
        "office_nm": "Pueblo Southeast Colorado Office"
      },
      {
        "office_id": "388",
        "office_nm": "Rocky Mountain Arsenal"
      },
      {
        "office_id": "620",
        "office_nm": "Pacific Islands Data Section"
      },
      {
        "office_id": "621",
        "office_nm": "Pacific Islands Projects"
      },
      {
        "office_id": "622",
        "office_nm": "Boise Field Office"
      },
      {
        "office_id": "623",
        "office_nm": "Idaho Falls Field Office"
      },
      {
        "office_id": "1033",
        "office_nm": "Idaho National Laboratory"
      },
      {
        "office_id": "1039",
        "office_nm": "Idaho WSC Wells"
      },
      {
        "office_id": "364",
        "office_nm": "Hays Field Office"
      },
      {
        "office_id": "363",
        "office_nm": "Lawrence Field Office"
      },
      {
        "office_id": "1003",
        "office_nm": "Lawrence Studies Office"
      },
      {
        "office_id": "365",
        "office_nm": "Wichita Field Office"
      },
      {
        "office_id": "1004",
        "office_nm": "Wichita Studies Office"
      },
      {
        "office_id": "336",
        "office_nm": "Lincoln - Science Center"
      },
      {
        "office_id": "337",
        "office_nm": "North Platte - Field Office"
      },
      {
        "office_id": "631",
        "office_nm": "Carson City - Water Science Center"
      },
      {
        "office_id": "632",
        "office_nm": "Henderson - Integrated Science Center"
      },
      {
        "office_id": "636",
        "office_nm": "Henderson -ISC Projects"
      },
      {
        "office_id": "341",
        "office_nm": "Albuquerque Field Office"
      },
      {
        "office_id": "927",
        "office_nm": "New Jersey Water Science Center"
      },
      {
        "office_id": "340",
        "office_nm": "Albuquerque Projects Office"
      },
      {
        "office_id": "343",
        "office_nm": "Las Cruces Field Office"
      },
      {
        "office_id": "372",
        "office_nm": "Coram Office"
      },
      {
        "office_id": "1022",
        "office_nm": "Rio Arriba Field Office"
      },
      {
        "office_id": "1024",
        "office_nm": "Coram Projects"
      },
      {
        "office_id": "1051",
        "office_nm": "Potsdam Office"
      },
      {
        "office_id": "1021",
        "office_nm": "Troy Projects"
      },
      {
        "office_id": "644",
        "office_nm": "Idaho WSC - BFO"
      },
      {
        "office_id": "643",
        "office_nm": "Oregon WSC - CPFO"
      },
      {
        "office_id": "1052",
        "office_nm": "Milford Office"
      },
      {
        "office_id": "676",
        "office_nm": "Oregon WSC - GHS"
      },
      {
        "office_id": "1019",
        "office_nm": "Oregon WSC - KFFO"
      },
      {
        "office_id": "642",
        "office_nm": "Oregon WSC - PFO"
      },
      {
        "office_id": "1028",
        "office_nm": "Oregon WSC - QA/QC"
      },
      {
        "office_id": "1011",
        "office_nm": "Oregon WSC - WVO"
      },
      {
        "office_id": "645",
        "office_nm": "Washington WSC - MCFO"
      },
      {
        "office_id": "382",
        "office_nm": "Acid-Mine Drainage"
      },
      {
        "office_id": "383",
        "office_nm": "Chester County Biological"
      },
      {
        "office_id": "384",
        "office_nm": "Chester County Ground Water"
      },
      {
        "office_id": "367",
        "office_nm": "Downingtown Field Office"
      },
      {
        "office_id": "385",
        "office_nm": "Miscellaneous Projects"
      },
      {
        "office_id": "368",
        "office_nm": "Pennsylvania Water Science Center"
      },
      {
        "office_id": "369",
        "office_nm": "Pittsburgh Field Office"
      },
      {
        "office_id": "381",
        "office_nm": "Water-Quality Network"
      },
      {
        "office_id": "370",
        "office_nm": "Williamsport Field Office"
      },
      {
        "office_id": "646",
        "office_nm": "Cedar City Field Office"
      },
      {
        "office_id": "647",
        "office_nm": "Moab Field Office"
      },
      {
        "office_id": "648",
        "office_nm": "Salt Lake City Water Science Center"
      },
      {
        "office_id": "652",
        "office_nm": "Cascades Volcano Observatory"
      },
      {
        "office_id": "653",
        "office_nm": "Mid-Columbia Field Office"
      },
      {
        "office_id": "654",
        "office_nm": "Northwest Washington Field Office"
      },
      {
        "office_id": "651",
        "office_nm": "Upper Columbia Field Office"
      },
      {
        "office_id": "655",
        "office_nm": "Washington WSC Projects"
      },
      {
        "office_id": "650",
        "office_nm": "Western Washington Field Office"
      },
      {
        "office_id": "1020",
        "office_nm": "PASS Operations"
      },
      {
        "office_id": "1025",
        "office_nm": "Grand Forks Field Office"
      },
      {
        "office_id": "662",
        "office_nm": "Pierre Field Office"
      },
      {
        "office_id": "661",
        "office_nm": "Huron Programs Office"
      },
      {
        "office_id": "663",
        "office_nm": "Rapid City Office"
      },
      {
        "office_id": "627",
        "office_nm": "Grand Forks Field Office (MN)"
      },
      {
        "office_id": "943",
        "office_nm": "Grayling Field Office"
      },
      {
        "office_id": "628",
        "office_nm": "Grand Rapids Field Office"
      },
      {
        "office_id": "944",
        "office_nm": "Lansing Field Office"
      },
      {
        "office_id": "1040",
        "office_nm": "Michigan WSC Projects"
      },
      {
        "office_id": "669",
        "office_nm": "Minnesota Projects"
      },
      {
        "office_id": "355",
        "office_nm": "Middleton Wisconsin"
      },
      {
        "office_id": "629",
        "office_nm": "Mounds View Field Office"
      },
      {
        "office_id": "356",
        "office_nm": "Northern Wisconsin"
      },
      {
        "office_id": "942",
        "office_nm": "Upper Peninsula Field Office"
      },
      {
        "office_id": "1055",
        "office_nm": "Wisconsin Projects"
      },
      {
        "office_id": "345",
        "office_nm": "Columbus Field Office"
      },
      {
        "office_id": "319",
        "office_nm": "Indianapolis Office"
      },
      {
        "office_id": "321",
        "office_nm": "Louisville District Office"
      },
      {
        "office_id": "322",
        "office_nm": "Murray Field Office"
      },
      {
        "office_id": "346",
        "office_nm": "New Philadelphia Field Office"
      },
      {
        "office_id": "323",
        "office_nm": "Williamsburg Field Office"
      },
      {
        "office_id": "311",
        "office_nm": "Council Bluffs Field Office"
      },
      {
        "office_id": "316",
        "office_nm": "DeKalb Field Office"
      },
      {
        "office_id": "312",
        "office_nm": "Fort Dodge Field Office"
      },
      {
        "office_id": "1066",
        "office_nm": "GW CRN"
      },
      {
        "office_id": "1046",
        "office_nm": "Illinois Investigations"
      },
      {
        "office_id": "313",
        "office_nm": "Iowa City Field Office"
      },
      {
        "office_id": "399",
        "office_nm": "Iowa Investigations"
      },
      {
        "office_id": "326",
        "office_nm": "Missouri Department of Natural Resources"
      },
      {
        "office_id": "317",
        "office_nm": "Mt. Vernon Field Office"
      },
      {
        "office_id": "358",
        "office_nm": "Olivette Field Office"
      },
      {
        "office_id": "324",
        "office_nm": "Rolla Field Office"
      },
      {
        "office_id": "315",
        "office_nm": "Urbana Field Office"
      },
      {
        "office_id": "392",
        "office_nm": "Water Quality Field Office Rolla"
      },
      {
        "office_id": "1056",
        "office_nm": "Evaluate Improved Streamflow Measurement at TxDOT Bridges"
      },
      {
        "office_id": "352",
        "office_nm": "Fort Worth - Field Office"
      },
      {
        "office_id": "349",
        "office_nm": "Houston - Program Office"
      },
      {
        "office_id": "396",
        "office_nm": "Lubbock -  Field Office"
      },
      {
        "office_id": "638",
        "office_nm": "Oklahoma City Office"
      },
      {
        "office_id": "1018",
        "office_nm": "Oklahoma Studies"
      },
      {
        "office_id": "347",
        "office_nm": "San Antonio - Program Office"
      },
      {
        "office_id": "1070",
        "office_nm": "TCEQ Data Project"
      },
      {
        "office_id": "639",
        "office_nm": "Tulsa Field Office"
      },
      {
        "office_id": "351",
        "office_nm": "Wichita Falls - Field Office"
      },
      {
        "office_id": "640",
        "office_nm": "Woodward Field Office"
      }
    ]
  }